import gql from 'graphql-tag';
import { UserAllDataFragment } from '../fragments';

export default gql`
mutation loginAsUser ($id: ID!) {
    loginAsUser (id: $id) {
        token
        user {
            ...UserAllDataFragment
        }
    }
}
${UserAllDataFragment}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/loginAsUser.ts